module.exports = __webpack_public_path__ + "images/ca35920ff57ed72ebb76e0fed4d7e7d4-profile_overlay.jpg";